<template>
    <div class="d-flex align-items-center w-100 e3-modal-header">
        <h5 class="d-flex w-100 m-0 mr-3 text-break">
            <slot/>
        </h5>
        <RoundIconButton class="ml-auto" type="bg-transparent" @click="closeFunc ? closeModal() : $bvModal.hide(modalName)">
            <CloseCircleIcon class="text-danger" size="27"/>
        </RoundIconButton>
    </div>
</template>

<script>
import CloseCircleIcon from '@/common/components/svg-icons/CloseCircleIcon.vue';

export default {
    props: {
        modalName: String,
        closeFunc: Boolean
    },
    methods: {
        closeModal() {
            this.$emit('modalCloseFunc', this.modalName);
        }
    },
    components: {
        CloseCircleIcon
    }
};
</script>

<style lang="scss" scoped>
.e3-modal-header {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
}
</style>
